import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function Gallery(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'Gallery',
		componentId: uuidv4(),
		props: _.merge({}, props),
		childrenComponents,
		blocks,
	};
}
